import { Button, Grid, Tab, Tabs, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import LockIcon from "@material-ui/icons/Lock";
import { EContractTab, EProcessNames } from "api/enums";
import ModalAttachmentsContract from "components/Attachments/ModalAttachmentsContract";
import MenuLeftSideBar from "components/Contract/MenuLeftSideBar";
import MeasurementTab from "components/Measurement/MeasurementTab";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ContractTable from "../components/Contract/ContractTable";
import IndicatorsTab from "../components/Indicators/IndicatorsTab";
import Header from "../components/Project/Header";
import MonetaryCard from "../components/UI/Fields/MonetaryCard";
import { PageHeader } from "../components/UI/Page";
import TabPanel from "../components/UI/Tabs/TabPanel";
import { lang } from "../i18nLang";
import {
  AccessProfileStore,
  ContractStore,
  MeasurementStore,
  MessageStore,
} from "../store";

const useStyles = makeStyles((theme) => ({
  tabsContent: { height: "100%", flexGrow: 2 },
  tabWrapper: {
    flexDirection: "row",
    "& svg": {
      margin: "0 10px 5px 10px !important",
    },
  },
  attachButton: {
    border: `1px solid ${theme.palette.gray[400]}`,
    padding: theme.spacing(2),
    minWidth: 42,
  },
  attachIcon: {
    transform: "rotate(40deg)",
    color: theme.palette.gray[600],
  },
}));

const Contract = observer(({ title }: any) => {
  const classes = useStyles();
  const history = useHistory();
  const { currentContractTotal, flagCurrentContractChanged } = ContractStore;
  const contract = ContractStore.getCurrentContract();
  const [contractTotal, setContractTotal] = useState(currentContractTotal);
  const [balanceTotal, setBalanceTotal] = useState(0);
  const [openContractAttach, setOpenContractAttach] = useState(false);

  const openMenu = Boolean(ContractStore.openLeftSideMenu);
  const currentTab = ContractStore.currentTabOpened;

  useEffect(() => {
    setContractTotal(currentContractTotal);
    setBalanceTotal(contract?.getBalanceTotal() || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flagCurrentContractChanged]);

  useEffect(() => {
    if (openMenu) {
      ContractStore.setCurrentTabOpened(EContractTab.CONTRACT);
    }
  }, [openMenu]);

  const handleChange = (event, newValue: number) => {
    if (
      newValue === 0 &&
      !AccessProfileStore.validateAccessPermissionTo(EProcessNames.INDICADORES)
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    ContractStore.setCurrentTabOpened(newValue);
  };

  const handleClickNewMeasurement = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.GERAR_MEDICOES
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }

    MeasurementStore.createMeasurement().then((uid) => {
      history.push(
        `/${ContractStore.getCurrentContract()?.uid}/measurement/${uid}`
      );
    });
  };

  const handleOpenContractAttach = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.ANEXAR_ARQUIVOS
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }

    setOpenContractAttach(true);
  };

  const handleCloseContractAttach = () => {
    setOpenContractAttach(false);
  };

  const iconLock = openMenu ? <LockIcon fontSize="small" /> : undefined;

  return (
    <Grid container style={{ height: "100%" }}>
      {openMenu && (
        <Grid
          container
          item
          xs
          style={{
            maxWidth: 248,
          }}
        >
          <MenuLeftSideBar />
        </Grid>
      )}
      <Grid
        container
        item
        xs
        direction="column"
        style={{
          maxWidth: openMenu ? "calc(100vw - 288px)" : "calc(100vw - 40px)",
        }}
      >
        <Header title={title} type="contract" showSettings={true} />
        <PageHeader>
          <Tabs
            value={currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            className={classes.tabsContent}
          >
            <Tab
              classes={{ wrapper: classes.tabWrapper }}
              label={lang("indicators")}
              icon={iconLock}
              disabled={openMenu}
            />
            <Tab
              classes={{ wrapper: classes.tabWrapper }}
              label={lang("measurement")}
              icon={iconLock}
              disabled={openMenu}
            />
            <Tab label={lang("contract.label")} />
          </Tabs>
          {currentTab === EContractTab.MEASUREMENT && (
            <Button
              variant={"outlined"}
              color={"primary"}
              onClick={handleClickNewMeasurement}
              style={{ margin: "1rem 0" }}
            >
              <AddIcon />
              {lang("measurements.newMeasurement")}
            </Button>
          )}
          {currentTab === EContractTab.CONTRACT && contract?.hasAttachments() && (
            <Button
              className={classes.attachButton}
              onClick={handleOpenContractAttach}
            >
              <AttachFileIcon className={classes.attachIcon} />
            </Button>
          )}
          <MonetaryCard
            label={lang("fields.contractValue")}
            value={contractTotal}
            margin={[0, 0.25, 0, 1]}
          />
          <MonetaryCard
            label={lang("fields.contractBalance")}
            value={balanceTotal}
            margin={[0, 1, 0, 0.25]}
          />
        </PageHeader>
        <Grid container item xs>
          <TabPanel value={currentTab} index={EContractTab.INDICATOR}>
            <IndicatorsTab />
          </TabPanel>
          <TabPanel value={currentTab} index={EContractTab.MEASUREMENT}>
            <MeasurementTab />
          </TabPanel>
          <TabPanel value={currentTab} index={EContractTab.CONTRACT}>
            <ContractTable />
          </TabPanel>
        </Grid>
      </Grid>
      <ModalAttachmentsContract
        open={openContractAttach}
        onClose={handleCloseContractAttach}
      />
    </Grid>
  );
});

export default Contract;
